import { render, staticRenderFns } from "./SelecoesForm.vue?vue&type=template&id=bbf1b956&scoped=true"
import script from "./SelecoesForm.vue?vue&type=script&lang=js"
export * from "./SelecoesForm.vue?vue&type=script&lang=js"
import style0 from "./SelecoesForm.vue?vue&type=style&index=0&id=bbf1b956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf1b956",
  null
  
)

export default component.exports